<template>
  <div class="welcome-reward" :class="cssType">
    <div class="welcome-reward-title">
      {{ $t('poolParty.welcomeReward.title') }}
    </div>
    <div class="welcome-reward-desc">
      {{ $t('poolParty.welcomeReward.desc') }}
    </div>
    <div class="prop-list">
      <Prop v-for="(item, index) in globalConf.welcomeRewardGameProps" size="small" :key="index" :item="item" />
    </div>
    <!-- <p>
      , 状态：{{ globalConf.isReceivedWelcomeReward ? '已领取' : '未领取' }}
    </p> -->
    <PPButton v-if="!props.isRewardStartTime" type="gray" disabled>
      {{ $t('sf.notStart') }}
    </PPButton>
    <PPButton v-else-if="!globalConf.isReceivedWelcomeReward" type="green" @click="receiveWelcomeReward">
      {{ $t('poolParty.btnCanReceive') }}
    </PPButton>
    <PPButton v-else type="gray" disabled>
      {{ $t('poolParty.btnReceived') }}
    </PPButton>
    <RewardDialog v-model="showRewardDialog" :propList="rewardProps" :title="$t('poolParty.welcomeReward.title')" />
  </div>
</template>

<script setup>
import { inject, ref, defineProps } from 'vue'
import PoolPartyActApi from '@/config/poolPartyActApi'
import { toastService } from '@/utils/toastService'
import { isMobile } from '@/utils'
import PPButton from '../PPButton/index.vue'
import RewardDialog from '../Dialog/RewardDialog/index.vue'
import Prop from '../Prop/index.vue'
import { useLog } from '@/composables/useLog'
const log = useLog()
const cssType = isMobile ? 'mobile' : 'pc'
const globalConf = inject('globalConf')
const refreshUserDetail = inject('refreshUserDetail')

const showRewardDialog = ref(false)
const rewardProps = ref([])
const props = defineProps({
  isRewardStartTime: {
    type: Boolean,
    default: false
  }
})
const receiveWelcomeReward = async () => {
  if (globalConf.value.isReceivedWelcomeReward) {
    toastService.show('您已领取见面礼')
    return
  }
  await PoolPartyActApi.receiveWelcomeReward()
  rewardProps.value = globalConf.value.welcomeRewardGameProps
  showRewardDialog.value = true
  log.track('act_pp_receive_welcome_reward')
  await refreshUserDetail()
}
</script>

<style scoped lang='less' src='./pc_style.less'></style>
<style scoped lang='less' src='./mobile_style.less'></style>

